var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 3.74487H1.62606C1.46598 3.74487 1.31245 3.65511 1.19925 3.49535C1.08605 3.33558 1.02246 3.11889 1.02246 2.89294C1.02246 2.667 1.08605 2.45031 1.19925 2.29054C1.31245 2.13077 1.46598 2.04102 1.62606 2.04102H14.35C14.5101 2.04102 14.6636 2.13077 14.7768 2.29054C14.89 2.45031 14.9536 2.667 14.9536 2.89294C14.9536 3.11889 14.89 3.33558 14.7768 3.49535C14.6636 3.65511 14.5101 3.74487 14.35 3.74487Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90146 9.04565H1.62606C1.46598 9.04565 1.31245 8.9559 1.19925 8.79613C1.08605 8.63636 1.02246 8.41967 1.02246 8.19372C1.02246 7.96778 1.08605 7.75109 1.19925 7.59132C1.31245 7.43155 1.46598 7.3418 1.62606 7.3418H9.90146C10.0615 7.3418 10.2151 7.43155 10.3283 7.59132C10.4415 7.75109 10.5051 7.96778 10.5051 8.19372C10.5051 8.41967 10.4415 8.63636 10.3283 8.79613C10.2151 8.9559 10.0615 9.04565 9.90146 9.04565Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41669 13.9675H1.62606C1.46598 13.9675 1.31245 13.8778 1.19925 13.718C1.08605 13.5582 1.02246 13.3415 1.02246 13.1156C1.02246 12.8897 1.08605 12.673 1.19925 12.5132C1.31245 12.3534 1.46598 12.2637 1.62606 12.2637H5.41669C5.57677 12.2637 5.7303 12.3534 5.8435 12.5132C5.9567 12.673 6.02029 12.8897 6.02029 13.1156C6.02029 13.3415 5.9567 13.5582 5.8435 13.718C5.7303 13.8778 5.57677 13.9675 5.41669 13.9675Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c13c21b2d5e42bca2b239638e682bf4a.svg";
export { ForwardRef as ReactComponent };